import { gql } from "@apollo/client";
import GraphQlService from "./graphql";

class customReportGraphql extends GraphQlService {
  async createCustomReportTemplate(data) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          createCustomReportTemplate(createCustomReportTemplateInput: {
            name: "${data.name}",
            description: "${data.description}",
            content: """${data.content}""",
            accountId : "${data.accountId}"
            screenType: "${data.screenType}"
            accessType: "${data.accessType}"
            public: ${data.public}
            active: ${data.active}
            autoSave: ${data.autoSave}
          }) {
            id
          }
        }
      `,
      })
      .then((res) => res.data.createCustomReportTemplate);
  }

  async getAllCustomReportTemplates(fromStatistics = false) {
    return this.client
      .query({
        query: gql`
          query GetAllCustomReportTemplates($fromStatistics: Boolean) {
            getAllCustomReportTemplates(fromStatistics: $fromStatistics) {
              id
              name
              description
              content
              accountId
              screenType
              accessType
              public
              active
            }
          }
        `,
        variables: { fromStatistics },
      })
      .then((res) => res.data.getAllCustomReportTemplates);
  }

  async getCustomReportTemplate(id) {
    return this.client
      .query({
        query: gql`
          query {
            getCustomReportTemplate(id: "${id}") {
              id
              name
              description
              content
              accountId
              screenType
              accessType
              public
              active
              autoSave
            }
          }
        `,
      })
      .then((res) => res.data.getCustomReportTemplate);
  }

  async updateCustomReportTemplate(data) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          updateCustomReportTemplate(updateCustomReportTemplateInput: {
            id: "${data.id}",
            name: "${data.name}",
            description: "${data.description}",
            content: """${data.content}""",
            accountId : "${data.accountId}"
            screenType: "${data.screenType}"
            accessType: "${data.accessType}"
            public: ${data.public}
            active: ${data.active}
            autoSave: ${data.autoSave}
          }) {
            id
          }
        }
      `,
      })
      .then((res) => res.data.updateCustomReportTemplate);
  }

  async updateCustomReportTemplateAutoSave(id, autoSave) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          updateCustomReportTemplateAutoSave(updateCustomReportTemplateAutoSaveInput: {
            id: "${id}",
            autoSave: ${autoSave}
          }) {
            id
            autoSave
          }
        }
      `,
      })
      .then((res) => res.data.updateCustomReportTemplateAutoSave);
  }

  async removeCustomReportTemplate(id) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          removeCustomReportTemplate(id: "${id}")
        }
      `,
      })
      .then((res) => res.data.removeCustomReportTemplate);
  }

  async getCustomRolesByCurrentUserForCustomReport(accountId = null) {
    return this.client
      .query({
        query: gql`
          query {
            getCustomRolesByCurrentUserForCustomReport(
              accountId: ${accountId ? `"${accountId}"` : null}
            ) {
              id
              accountId
              organizationName
              nameENG
              nameSW
              count
            }
          }
        `,
      })
      .then((res) => res.data.getCustomRolesByCurrentUserForCustomReport);
  }

  async setCustomReportConfig(data) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          setCustomReportConfig(setCustomReportConfigInput: {
            reportTemplateId: "${data.reportTemplateId}",
            isAllowForReminder: ${data.allowReminder},
            allowAnonymousReports: ${data.allowAnonymousReports},
            customRoles: """${JSON.stringify(data.customRoles)}"""
            secretLevel: "${data.secretLevel}",
          }) 
        }
      `,
      })
      .then((res) => res.data.setCustomReportConfig);
  }

  async createCustomReportReport(data) {
    return this.client
      .mutate({
        mutation: gql`
          mutation CreateCustomReportReport(
            $input: CreateCustomReportReportInput!
          ) {
            createCustomReportReport(createCustomReportReportInput: $input) {
              id
            }
          }
        `,
        variables: {
          input: {
            content: JSON.stringify(data.content),
            reportConfigId: data.reportConfigId,
            userId: JSON.stringify(data.userId ?? null),
            counsellorId: JSON.stringify(data.counsellorId ?? null),
            template: JSON.stringify(data.template),
            templateName: data.templateName,
            journalTypeId: data.journalTypeId,
            anonymousData: data.anonymousData
              ? JSON.stringify(data.anonymousData)
              : null,
            processTaskId: data.processTaskId,
            processConfigId: data.processConfigId,
          },
        },
      })
      .then((res) => res.data.createCustomReportReport);
  }

  async updateCustomReportReport(data) {
    return this.client
      .mutate({
        mutation: gql`
          mutation UpdateCustomReportReport(
            $input: UpdateCustomReportReportInput!
          ) {
            updateCustomReportReport(updateCustomReportReportInput: $input) {
              id
            }
          }
        `,
        variables: {
          input: {
            id: data.id,
            content: JSON.stringify(data.content),
          },
        },
      })
      .then((res) => res.data.updateCustomReportReport);
  }

  async getTempCustomReports(id) {
    return this.client
      .query({
        query: gql`
          query {
            getTempCustomReports(id: "${id}") {
              text
            }
          }
        `,
      })
      .then((res) => res.data.getTempCustomReports);
  }

  async removeTempCustomReports(id) {
    return this.client
      .mutate({
        mutation: gql` 
        mutation {
          removeTempCustomReports(id: "${id}"){
           
           text
           
          }
    }`,
      })
      .then((res) => res.data.removeTempCustomReports);
  }

  async findAllUsersByCustomRolesId(customRolesId) {
    return this.client
      .query({
        query: gql`
          query {
            findAllUsersByCustomRolesId(customRolesId: "${customRolesId}") {
              id
              accountId
              userId
              organizationId
              organizationName
              name
              type
              isAnonymous
              profilePictureName
              about
              birthday
              gender
              createdAt
              updatedAt
              createdBy
              updatedBy
              version
              email
              isOnline
              allowEmailNotification
              profileVideoName
              isSecretIdentity
              color
              customRoles {
                id
                nameENG
                nameSW
                masterRolesId
              }
            }
          }
        `,
      })
      .then((res) => res.data.findAllUsersByCustomRolesId);
  }

  async getCustomReportConfigsByTemplateNames(templateNames) {
    return this.client
      .query({
        query: gql`
          query GetCustomReportConfigsByTemplateNames(
            $templateNames: [String!]!
          ) {
            getCustomReportConfigsByTemplateNames(
              templateNames: $templateNames
            ) {
              id
              reportTemplateId
              accountId
              active
              reportTemplate {
                id
                name
                accessType
              }
            }
          }
        `,
        variables: { templateNames },
        fetchPolicy: "network-only",
      })
      .then((res) => res.data.getCustomReportConfigsByTemplateNames);
  }

  async getCustomReportConfigsByCurrentUser() {
    return this.client
      .query({
        query: gql`
          query {
            getCustomReportConfigsByCurrentUser {
              id
              secretLevel
              accountId
              reportTemplateId
              allowAnonymousReports
              isAllowForReminder
              active
              createdAt
              updatedAt
              createdBy
              updatedBy
              version
              reportTemplate {
                id
                name
                description
                content
                screenType
                accessType
              }
              customReportReports {
                id
              }
              account {
                name
              }
              customRoles {
                id
                nameSW
                nameENG
              }
            }
          }
        `,
      })
      .then((res) => res.data.getCustomReportConfigsByCurrentUser);
  }

  async getCustomReportConfigById(id) {
    return this.client
      .query({
        query: gql`
        query {
          getCustomReportConfig(id: "${id}") {
 
          id
          accountId
          reportTemplateId
          allowAnonymousReports
          isAllowForReminder
          active
          reportTemplate{
            content
            name
            screenType
            accessType
          }
      }}
      `,
      })
      .then((res) => res.data.getCustomReportConfig);
  }

  async updateCustomReportRoles(data) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          updateCustomReportRoles(updateCustomReportRolesInput: {
            customRoleIds: """${JSON.stringify(data.customRoleIds)}""",
            reportConfigId: "${data.reportConfigId}"
          }) 
        }
      `,
      })
      .then((res) => res.data.updateCustomReportRoles);
  }

  async getCombinedReportResultsByTemplateId(data) {
    return this.client
      .query({
        query: gql`
          query {
            getCombinedReportResultsByTemplateId(
              getReportStatisticsInput: {
                dtStart:"${data.dtStart}"
                dtEnd:"${data.dtEnd}"
                templateId: "${data.templateId}"
                deepFilterData: ${
                  data.deepFilterData.length > 0
                    ? `"""${JSON.stringify(data.deepFilterData)}"""`
                    : null
                }
                userId : ${
                  data.userId.length > 0
                    ? `"""${JSON.stringify(data.userId)}"""`
                    : null
                }
                resultId: ${
                  data.resultId.length > 0
                    ? `"""${JSON.stringify(data.resultId)}"""`
                    : null
                }
                filters: ${
                  data.filters.length > 0
                    ? `"""${JSON.stringify(data.filters)}"""`
                    : null
                }
              }
            ) {
              getAllReportResultsByTemplateId {
                amountOfReports
                isShowStudentList
                resultIds
                questions {
                  questionName
                  questionType
                  unansweredCount
                  unansweredUserId
                  unansweredResultIds
                  unansweredPercentage
                  otherAnswers{
                    resultId
                    answer
                  }
                  options {
                    name
                    value
                    count
                    studentIds
                    resultIds
                    surveyQuestionName
                    __typename
                  }
                  __typename
                }
                __typename
              }
              getRecursionChartsDataReportQuestions {
                startDate
                endDate
                label
                type
                data {
                  questionName
                  questionType
                  unansweredCount
                  unansweredPercentage
                  unansweredUserId
                  otherAnswers{
                    resultId
                    answer
                  }
                  options {
                    name
                    value
                    count
                    studentIds
                    surveyQuestionName
                    __typename
                  }
                  __typename
                }
              }
            }
          }
        `,
      })
      .then((res) => res.data.getCombinedReportResultsByTemplateId);
  }

  async getStatisticsUsersAndResultsByTemplateId(data) {
    return this.client
      .query({
        query: gql`
          {
            getStatisticsUsersAndResultsByTemplateId(
              getStatisticsUsersAndResultsByTemplateIdInput: {
                dtStart: "${data.dtStart}"
                dtEnd: "${data.dtEnd}"
                templateId: "${data.templateId}"
                userId: ${
                  data.userId.length > 0
                    ? `"""${JSON.stringify(data.userId)}"""`
                    : null
                }
                resultId: ${
                  data.resultId.length > 0
                    ? `"""${JSON.stringify(data.resultId)}"""`
                    : null
                }
                filters: ${
                  data.filters.length > 0
                    ? `"""${JSON.stringify(data.filters)}"""`
                    : null
                }
              }
            ) {
              users {
                  id
                  email
                  status
                  createdAt
                  resetPasswordToken
                  accountPeople {
                    id
                    accountId
                    organizationName
                    type
                    isOnline
                    about
                    gender
                    email
                    profilePictureName
                    name
                    accountPersonAttributes {
                      id
                      accountId
                      name
                      value
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                reports {
                  id
                  accountId
                  reportConfigId
                  userId
                  anonymousData
                  content
                  createdAt
                  createdBy
                  createdByUser{
                    id
                    accountPeople {
                      id
                      accountId
                      name
                    }
                  }
                  user {
                    id
                    email
                    status
                    createdAt
                    resetPasswordToken
                    accountPeople {
                      id
                      accountId
                      organizationName
                      type
                      isOnline
                      about
                      gender
                      email
                      profilePictureName
                      name
                      accountPersonAttributes {
                        id
                        accountId
                        name
                        value
                        __typename
                      }
                      __typename
                    }
                  }
                  reportConfig {
                    reportTemplate {
                      id
                      name
                      accountId
                      description
                      screenType
                      accessType
                      public
                      active
                      __typename
                    }
                    account {
                      name
                      __typename
                    }
                    __typename
                  }
                    customReportTaggedUsers {
                      id
                      email
                      accountPeople{
                      id
                      accountId
                      organizationName
                      type
                      isOnline
                      about
                      gender
                      email
                      profilePictureName
                      name
                      accountPersonAttributes {
                        id
                        accountId
                        name
                        value
                        __typename
                      }
                      __typename
                     }
                    }
                  __typename
                }
              }
            }
          `,
      })
      .then((res) => res.data.getStatisticsUsersAndResultsByTemplateId);
  }

  async updateCustomReportConfigSecretLevel(data) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          updateCustomReportConfigSecretLevel(updateCustomReportConfigInput: {
            id: "${data.reportConfigId}",
            secretLevel: "${data.secretLevel}"
          }) {
            id          
          }
        }
      `,
      })
      .then((res) => res.data.updateCustomReportConfigSecretLevel);
  }

  async createCustomReportReportArchive(data) {
    return this.client
      .mutate({
        mutation: gql`
          mutation CreateCustomReportReportArchive(
            $input: CreateCustomReportReportArchiveInput!
          ) {
            createCustomReportReportArchive(
              createCustomReportReportArchiveInput: $input
            ) {
              id
            }
          }
        `,
        variables: {
          input: {
            userId: data.userId,
            customReportId: data.customReportId,
            reportConfigId: data.reportConfigId,
            accountId: data.accountId,
            content: JSON.stringify(data.content),
            anonymousData:
              data.anonymousData != null
                ? JSON.stringify(data.anonymousData)
                : null,
            status: data.status,
            reason: data.reason,
            template: data.template != null ? JSON.stringify(data.template) : null,
          },
        },
      })
      .then((res) => res.data.createCustomReportReportArchive);
  }

  async getCustomReportReportArchivesByCustomReportId(customReportId) {
    return this.client
      .query({
        query: gql`
          query {
            getCustomReportReportArchivesByCustomReportId(customReportId: "${customReportId}") {
              id
              accountId
              content
              reason
              status
              createdAt
              createdByUser {
                accountPeople {
                  userId
                  accountId
                  name
                  id
                }
              }
            }
          }
        `,
      })
      .then((res) => res.data.getCustomReportReportArchivesByCustomReportId);
  }

  async updateCustomReportReminder(data) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          updateCustomReportReminder(updateCustomReportConfigInput: {
            id: "${data.reportConfigId}",
            isAllowForReminder: ${data.isAllowForReminder}
          }) {
            id          
          }
        }
      `,
      })
      .then((res) => res.data.updateCustomReportReminder);
  }

  async signCustomReport(id, confirmedName) {
    return this.client
      .mutate({
        mutation: gql`
          mutation SignCustomReport($input: SignCustomReportInput!) {
            signCustomReport(signCustomReportInput: $input) {
              id
              signatureStatus
              signedBy
              signedAt
            }
          }
        `,
        variables: {
          input: { id, confirmedName },
        },
      })
      .then((res) => res.data.signCustomReport);
  }

  async unlockCustomReport(id, reason) {
    return this.client
      .mutate({
        mutation: gql`
          mutation UnlockCustomReport($input: UnlockCustomReportInput!) {
            unlockCustomReport(unlockCustomReportInput: $input) {
              id
              signatureStatus
              signedBy
              signedAt
              unlockedBy
              unlockedAt
              unlockReason
            }
          }
        `,
        variables: {
          input: { id, reason },
        },
      })
      .then((res) => res.data.unlockCustomReport);
  }

  async updateCustomReportAllowGuestEditing(id, allowGuestEditing) {
    return this.client
      .mutate({
        mutation: gql`
          mutation UpdateCustomReportAllowGuestEditing(
            $input: UpdateCustomReportAllowGuestEditingInput!
          ) {
            updateCustomReportAllowGuestEditing(
              updateCustomReportAllowGuestEditingInput: $input
            ) {
              id
              allowGuestEditing
            }
          }
        `,
        variables: {
          input: { id, allowGuestEditing },
        },
      })
      .then((res) => res.data.updateCustomReportAllowGuestEditing);
  }
}

const customReportGraphqlInstance = new customReportGraphql();
export default customReportGraphqlInstance;
